import { readCookie } from '../../Utility/CookieManager.js';

function main() {

    var gdpr_consent_val = null;
    if(readCookie('rc_tos_consent') == 'allow') {
        gdpr_consent_val = '1';
    } else if(readCookie('rc_tos_consent_seen_not_agreed') == '1') {
        gdpr_consent_val = '0';
    }
    window._comscore = window._comscore || [];
    _comscore.push({ c1: "2", c2: "22522699", cs_ucfr: gdpr_consent_val }); //GDPR (cs_ucfr: "0")
    (function() {
    var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
    s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js"; 
    el.parentNode.insertBefore(s, el);
    })();
    var comscore_elem = document.createElement("noscript");
    comscore_elem.innerHTML = '<img src="https://sb.scorecardresearch.com/p?c1=2&c2=22522699&cs_ucfr='+gdpr_consent_val+'&cv=2.0&cj=1" />'; //GDPR (&cs_ucfr=0)
    document.body.appendChild(comscore_elem);
    
    /**
     * If logged in with no ad free account
     */
    window._gaq = window._gaq || []; // Since we'll be pushing custom vars
    
    if( readCookie('rcmg_guid') && readCookie('rcmg_token') && (readCookie('evaf') == null || parseInt(readCookie('evaf')) == 0) ){

      _gaq.push(['_setCustomVar',
        1,           // Slot (1 - 5)
        'Logged In', // Name
        'Yes',       // Value
        2            // 1 - page level, 2 - session level, 3 - visitor level
      ]);

    }

    //Custom Tracking - Adblocker Users who signed up for Newsletter via AD Notifier Widget(evolok)
    if( readCookie('two_weeks_adfree') ){

      _gaq.push(['_setCustomVar',
        2,           // Slot (1 - 5) 
        'Newsletter Ad Free Access', // Name
        'Yes',       // Value
        2            // 1 - page level, 2 - session level, 3 - visitor level
      ]);

    }


    /**
     * If logged in with ad free account create var
     */
    if( readCookie('rcmg_guid') && readCookie('rcmg_token') && parseInt(readCookie('evaf')) == 1 ){

      _gaq.push(['_setCustomVar',
        3,           // Slot (1 - 5)
        'Logged In With Ad Free', // Name
        'Yes',       // Value
        2            // 1 - page level, 2 - session level, 3 - visitor level
      ]);
      
    }


    /**
     * If logged in with an blocker
     */
    setTimeout(function(){

        if( readCookie('rcmg_guid') && readCookie('rcmg_token') && Utils.global_settings.realclear_ad_block_check ){

          _gaq.push(['_setCustomVar',
            4,           // Slot (1 - 5)
            'Logged In With Ad Block', // Name
            'Yes',       // Value
            2            // 1 - page level, 2 - session level, 3 - visitor level
          ]);
        }

    }, 1600);

    // jquery plugin scrollDepth removed, no longer needed. Was included here.

    window._qevents = window._qevents || [];

    (function() {
    var elem = document.createElement('script');
    elem.src = (document.location.protocol == "https:" ? "https://secure" : "http://edge") + ".quantserve.com/quant.js";
    elem.async = true;
    elem.type = "text/javascript";
    var scpt = document.getElementsByTagName('script')[0]; 
    scpt.parentNode.insertBefore(elem, scpt);
    })();

    _qevents.push({
    qacct:"p-9bKF-NgTuSFM6"
    });
    var quant_elem = document.createElement("noscript");
    quant_elem.innerHTML = '<div style="display:none;"><img src="//pixel.quantserve.com/pixel/p-9bKF-NgTuSFM6.gif" border="0" height="1" width="1" alt="Quantcast"/></div>';
    document.body.appendChild(quant_elem);

    //GETS THE CURRENT <BODY> CLASS
    var cur_body_class = document.body.getAttribute('class').split(/\s+/);

    //ad block check
    $(document).ready(function(){
        setTimeout(function(){
            warning_widget.check_ad_block_status();
        },125);
    });

    /*load mobile ad */
    if(viewportSize.getWidth()<768) {

        var s=document.createElement('script'); 
        s.type='text/javascript'; 
        s.async=true; 
        s.src='//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
        var x=document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s,x);

        var adsbygoogle = null;

         (adsbygoogle = window.adsbygoogle || []).push({ 
            google_ad_client: "ca-pub-4560167926987914",
            enable_page_level_ads: true
         });             
    }

    var s_bk =document.createElement('script');
        s_bk.type='text/javascript';
        s_bk.async=true;
        s_bk.src='//tags.bluekai.com/site/3537?ret=js';
        var x_bk=document.getElementsByTagName('script')[0];
        x_bk.parentNode.insertBefore(s_bk,x_bk);


    //google+ js sdk
    !function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src="https://apis.google.com/js/plusone.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","goggleplusshare");

    //linkedin js sdk
    !function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src="//platform.linkedin.com/in.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","linkedinshare");

}

//Dependency/Custom Lazy Loader - Non-Paralleled, Sequential Script Loader(Async)
function loadAsyncScript(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    if (script.readyState) {
        script.onreadystatechange = function () {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                if (callback && typeof callback === "function") {
                    callback();
                }
            }
        };
    } else {
        script.onload = function () {
            if (callback && typeof callback === "function") {
                callback();
            }
        };
    }
    script.src = url;
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
}

window.checkIfAnalyticsLoaded2 = function() {
    if (window._gat && window._gat._getTracker) {

        //RCP SURVEY BEACON 
        //var rcp_google_beacon = readCookie('rcp_google_beacon_1019');

        //if(!rcp_google_beacon){

            /*

            var makeid = function(length) {
                var text = "";
                var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

                for (var i = 0; i < length; i++){
                    text += possible.charAt(Math.floor(Math.random() * possible.length)); 
                }

                return text;
            }

            var millis = Date.now();
            user_identifier = millis+"_"+makeid(8)+"|0";

            createCookie("rcp_google_beacon_1019", user_identifier, 365);

            var data = {
                'ge_category' : 'RCP_Survey_Tracking_Beacon_1019',
                'ge_action' : 'Hit',                
                'ge_label' : "0",
            };

            send_ga_event(data);

            */

        //}

        
    } else {
        //check in 500 ms
        setTimeout('checkIfAnalyticsLoaded2()', 1000);
    }
}

export default main;